import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import constants from '../../../config/constants';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import { withCart } from '../../../utils/CartContext';
import { getErrorMessage } from '../../../utils/errorHandler';
import { allowOnlyNumbers } from '../../../utils/jsUtils';
import { withLabels } from '../../../utils/LabelsContext';
import _ from '../../../utils/LodashImports';
import { noop } from '../../../utils/noop';
import { withProduct } from '../../../utils/ProductContext';
import { getVariant } from '../../../utils/variant';
import Image from '../../ui/Image/Image';
import { CartItemStyles } from './CartItem.style';
import { createOption, getViewConfig, handleErrors, handleEvents } from './CartItem.util';
import CartItemAdditionalInformation from './CartItemComponents/CartItemAdditionalInformation';

const CartItem = ({
  item,
  onAddToCart,
  onRemoveFromCart,
  setWarrantyOption,
  showWarrantyOption,
  setBusy,
  labels,
  showButton,
  appCtx,
  isAtgPrice,
  type,
  showAssemblyOption,
  product,
  setCrossSelling,
  variantDetails,
  disableQuantitySelection,
  setWarrantyOptionCurrent,
  limitAlerts,
  cart,
}) => {
  const {
    brandName,
    name,
    skuId,
    image,
    productId,
    offeringId,
    price,
    totalQuantity,
    commerceItemId,
    warrantyOptions,
    assemblyOptions,
    addedQuantity,
    cartLineId = '',
    childProducts = [],
  } = item;
  const [showMaxQuantityAlert, setShowMaxQuantityAlert] = useState(false);
  const [errorAddingToCart, setErrorAddingToCart] = useState('');
  const [limitFromAPI, setLimitFromAPI] = useState(false);
  const [inputVal, setInputVal] = useState(totalQuantity);

  const { deviceType } = appCtx;
  const isQuantityEditableEnabled = _.get(appCtx, 'siteConfig.toggles.isQuantityEditableEnabled', false);
  const timeputForLoginModalOn401 = _.get(appCtx, 'siteConfig.textDictionary.TIMEOUT_FOR_LOGIN_MODAL', 1000);

  const currentVariant = getVariant(product.variants, product.currentVariant);
  const { maxOnCartAmount } = currentVariant;
  const isDesktop = deviceType === 'desktop';

  useEffect(() => {
    if (limitAlerts && (limitAlerts[cartLineId] || limitAlerts.basket)) {
      setLimitFromAPI(true);
      if (limitAlerts[cartLineId]) {
        setErrorAddingToCart(limitAlerts[cartLineId].message);
      } else {
        setErrorAddingToCart(limitAlerts.basket.message);
      }
    } else {
      setLimitFromAPI(false);
    }
  }, [limitAlerts]);
  useEffect(() => {
    setInputVal(totalQuantity);
    const eventToDigitalData = new CustomEvent('DDPDPUpdateSelectedProductCount', {
      bubbles: true,
      detail: totalQuantity,
    });
    window.dispatchEvent(eventToDigitalData);
  }, [totalQuantity]);

  const handleWarrantyOptionsSelected = (option) => {
    const value = option ? option.variantId || option.value : '';
    const warrantyOfferingId = _.get(option, 'offeringId', '');
    setBusy(true);
    setWarrantyOptionCurrent({ ...option, selected: true });
    setWarrantyOption({
      appCtx,
      item: { commerceItemId, skuId: value },
      productContext: product,
      variantId: skuId,
      setWarrantyOptionCurrent,
      cartLineId: warrantyOptions.cartLineId || '',
      totalQuantity,
      offeringId: warrantyOfferingId,
    }).then(() => {
      setBusy(false);
    });
  };

  const handleAddItem = (currQuantity = 1, isClickedByUser = false) => {
    const maximumLimit = maxOnCartAmount || constants.MAX_CART_PRODUCT;
    if (totalQuantity === maximumLimit) {
      setShowMaxQuantityAlert(true);
      return;
    }
    setBusy(true);

    const selectedWarranty =
      warrantyOptions && warrantyOptions.cartLineId
        ? childProducts.find((cp) => cp.cartLineId === warrantyOptions.cartLineId)
        : {};

    const selectedService =
      assemblyOptions && assemblyOptions.cartLineId && totalQuantity > 0
        ? childProducts.find((cp) => cp.cartLineId === assemblyOptions.cartLineId)
        : {};

    const warrantySkuId = _.get(selectedWarranty, 'variantId', '');
    const warrantyOfferingId = _.get(selectedWarranty, 'offeringId', '');
    const serviceSkuId = _.get(selectedService, 'variantId', '');
    const serviceOfferingId = _.get(selectedService, 'offeringId', '');
    const isMaxLimitExceeded = inputVal > maximumLimit;

    const option = createOption({
      actionType: 'add',
      type,
      currQuantity,
      maximumLimit,
      warrantySkuId,
      warrantyOfferingId,
      serviceSkuId,
      serviceOfferingId,
      offeringId,
      skuId,
      productId,
      appCtx,
      inputVal,
      totalQuantity,
      disableServicesAndWarranties: false,
    });

    setErrorAddingToCart('');
    onAddToCart(option).then((res) => {
      handleErrors(res, getErrorMessage, cart, timeputForLoginModalOn401, setErrorAddingToCart, appCtx);
      handleEvents({
        actionType: 'add',
        isClickedByUser,
        res,
        inputVal,
        maxOnCartAmount,
      });
      if (isMaxLimitExceeded) {
        setShowMaxQuantityAlert(true);
        setInputVal(maximumLimit);
      }
      setBusy(false);
    });
  };

  const handleRemoveItem = (
    currQuantity = 1,
    disableServicesAndWarranties = false,
    cb = undefined,
    isClickedByUser = false
  ) => {
    setShowMaxQuantityAlert(false);
    setBusy(true);

    const option = createOption({
      actionType: 'remove',
      type,
      currQuantity,
      appCtx,
      disableServicesAndWarranties,
      cartLineId,
      commerceItemId,
      warrantyOptions,
      assemblyOptions,
      totalQuantity,
    });

    setErrorAddingToCart('');
    onRemoveFromCart(option).then((res) => {
      setBusy(false);
      handleEvents({
        actionType: 'remove',
        isClickedByUser,
        res,
        inputVal,
        maxOnCartAmount,
      });
      handleErrors(res, getErrorMessage, cart, timeputForLoginModalOn401, setErrorAddingToCart, appCtx);
      if (!res && cb) {
        cb();
      }
    });
  };

  const viewConfig = getViewConfig(deviceType);

  const showCartServicesSection = () => {
    return (showWarrantyOption && warrantyOptions) || (showAssemblyOption && assemblyOptions);
  };

  if (showCartServicesSection()) {
    setCrossSelling(true);
  }

  const getMaxForStepper = () => {
    if (limitFromAPI) {
      return totalQuantity;
    }
    const maximumLimit = maxOnCartAmount || constants.MAX_CART_PRODUCT;
    return showMaxQuantityAlert ? maximumLimit : maximumLimit + 1;
  };

  const getMaxForProductCounter = () => {
    if (limitFromAPI) {
      return totalQuantity;
    }
    const maximumLimit = maxOnCartAmount || constants.MAX_CART_PRODUCT;

    return maximumLimit;
  };

  const isMobile = !isDesktop;
  const mobileStyle = isDesktop ? { width: '100%' } : {};
  const mobileClass = isDesktop ? '' : 'mobile';
  const supportedKeyValues = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete'];

  const handleInputChange = (event, keyPressed) => {
    const { target } = event;
    let { value } = target;

    if (Number.isNaN(parseInt(value, 10))) {
      if (!inputVal || value.trim() === '') {
        setInputVal(undefined);
        target.value = '';
      } else {
        target.value = value.substring(0, value.length - 1);
      }
      return;
    }

    value = allowOnlyNumbers(value);
    if (value.length >= 4) {
      if (value.startsWith('0')) {
        value = value.slice(1, 4);
      } else {
        value = value.slice(0, 3);
      }
    }

    if ((keyPressed && !supportedKeyValues.includes(keyPressed)) || value > getMaxForProductCounter()) {
      return;
    }

    value = parseInt(value, 10);

    if (value < 1000) {
      setInputVal(value);
      target.value = value;
    }

    if (value > 1000) {
      setInputVal(totalQuantity);
      target.value = totalQuantity;
    }
    if (Number.isNaN(value)) {
      setInputVal(undefined);
    }
  };
  const handleQuantityInput = (keyPressed) => {
    if (keyPressed === 'ArrowLeft' || keyPressed === 'ArrowRight' || keyPressed === 'Backspace') {
      return;
    }

    setShowMaxQuantityAlert(false);

    let value = parseInt(inputVal, 10);

    if (value.length >= 4) {
      value = value.slice(0, 3);
    }
    if (value >= getMaxForProductCounter()) {
      setShowMaxQuantityAlert(true);
      value = getMaxForProductCounter();
    }
    if (Number.isNaN(value)) {
      setInputVal(totalQuantity);
      value = totalQuantity;
    }

    if (value < totalQuantity) {
      handleRemoveItem(totalQuantity - value, value === 0, () => {
        if (value === 0) {
          if (warrantyOptions.cartLineId) {
            handleWarrantyOptionsSelected();
          }
        }
      });
    } else if (value > totalQuantity) {
      const currValue = value - totalQuantity;
      handleAddItem(currValue);
    } else if (value === totalQuantity) {
      setInputVal(totalQuantity);
    }
  };

  const stepperStyle = (price && price.length) === 3 ? { marginTop: '15px' } : {};

  useEffect(() => {
    if (isQuantityEditableEnabled && totalQuantity > getMaxForProductCounter()) {
      handleRemoveItem(totalQuantity - getMaxForProductCounter());
      setShowMaxQuantityAlert(true);
    }
  }, []);
  return (
    <div className={`cart-item-wrapper ${mobileClass} mkp`} style={mobileStyle}>
      <div className="cart-item">
        <div className={`cart-item-image ${isDesktop ? 'cart-image-desktop' : 'cart-image-mobile'}`}>
          <Image
            id={currentVariant.id}
            imageUrl={image}
            width={isDesktop ? 52 : 120}
            height={isDesktop ? 52 : 120}
            alt={name}
            useSrcSet={false}
            inlineDimensions
            type="thumbnail"
            lazyLoad={isDesktop}
          />
        </div>
        <CartItemAdditionalInformation
          viewConfig={viewConfig}
          brandName={brandName}
          name={name}
          variantDetails={variantDetails}
          isMobile={isMobile}
          productId={productId}
          currentVariant={currentVariant}
          isAtgPrice={isAtgPrice}
          price={price}
          disableQuantitySelection={disableQuantitySelection}
          stepperStyle={stepperStyle}
          totalQuantity={totalQuantity}
          handleRemoveItem={handleRemoveItem}
          handleAddItem={handleAddItem}
          getMaxForStepper={getMaxForStepper}
          isQuantityEditableEnabled={isQuantityEditableEnabled}
          inputVal={inputVal}
          handleQuantityInput={handleQuantityInput}
          handleInputChange={handleInputChange}
          getMaxForProductCounter={getMaxForProductCounter}
          showButton={showButton}
          labels={labels}
          showMaxQuantityAlert={showMaxQuantityAlert}
          maxOnCartAmount={maxOnCartAmount}
          errorAddingToCart={errorAddingToCart}
          addedQuantity={addedQuantity}
          appCtx={appCtx}
          item={item}
        />
      </div>
      <style jsx>{CartItemStyles}</style>
    </div>
  );
};

CartItem.defaultProps = {
  onAddToCart: noop,
  onRemoveFromCart: noop,
  setBusy: noop,
  setWarrantyOption: noop,
  showWarrantyOption: true,
  showButton: true,
  type: '',
  isAtgPrice: true,
  showAssemblyOption: true,
  setCrossSelling: noop,
  variantDetails: '',
  disableQuantitySelection: false,
  setWarrantyOptionCurrent: noop,
  limitAlerts: undefined,
  cart: {},
};

CartItem.propTypes = {
  item: PropTypes.object.isRequired,
  onAddToCart: PropTypes.func,
  onRemoveFromCart: PropTypes.func,
  setBusy: PropTypes.func,
  appCtx: PropTypes.object.isRequired,
  setWarrantyOption: PropTypes.func,
  showWarrantyOption: PropTypes.bool,
  showAssemblyOption: PropTypes.bool,
  showButton: PropTypes.bool,
  labels: PropTypes.object.isRequired,
  type: PropTypes.string,
  isAtgPrice: PropTypes.bool,
  product: PropTypes.object.isRequired,
  setCrossSelling: PropTypes.func,
  variantDetails: PropTypes.string,
  disableQuantitySelection: PropTypes.bool,
  setWarrantyOptionCurrent: PropTypes.func,
  limitAlerts: PropTypes.object,
  cart: PropTypes.object,
};

export default withProduct(withLabels(withApplicationContext(withCart(CartItem))));
export { CartItem };
